import type { PrivilegeDefinition } from '@/core/be/security/SecurityTypes';
import type { FeatureModule } from '@/core/platform/features/FeatureModule';
import { IS_NEXT_EDGE_RUNTIME } from '@core/config/NextRuntime';

export const CommentPrivilegeIds = {
  read: 'comments:read',
  create: 'comments:create',
  edit: 'comments:edit',
  delete: 'comments:delete',
  resolve: 'comments:resolve',
  moderate: 'comments:moderate',
} as const;

const CommentPrivileges: PrivilegeDefinition[] = [
  {
    id: CommentPrivilegeIds.read,
    scope: 'vault',
    feature: 'comments',
    description: 'View comment threads within a vault.',
    subscriptionGated: true,
    subscriptionFeatureId: 'comments',
    label: 'Comments',
    tierRequired: 'pro',
  },
  {
    id: CommentPrivilegeIds.create,
    scope: 'vault',
    feature: 'comments',
    description: 'Post new comments or replies.',
    subscriptionGated: true,
    subscriptionFeatureId: 'comments',
    label: 'Comments',
    tierRequired: 'pro',
  },
  {
    id: CommentPrivilegeIds.edit,
    scope: 'vault',
    feature: 'comments',
    description: 'Edit own comments.',
    subscriptionGated: true,
    subscriptionFeatureId: 'comments',
    label: 'Comments',
    tierRequired: 'pro',
  },
  {
    id: CommentPrivilegeIds.delete,
    scope: 'vault',
    feature: 'comments',
    description: 'Delete own comments.',
    subscriptionGated: true,
    subscriptionFeatureId: 'comments',
    label: 'Comments',
    tierRequired: 'pro',
  },
  {
    id: CommentPrivilegeIds.resolve,
    scope: 'vault',
    feature: 'comments',
    description: 'Resolve comment threads.',
    subscriptionGated: true,
    subscriptionFeatureId: 'comments',
    label: 'Comments',
    tierRequired: 'pro',
  },
];

export class CommentsFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'comments',
    privileges: CommentPrivileges,
    bootstrap: async () => {
      // Only run on server side (Node.js runtime)
      if (typeof window !== 'undefined' || IS_NEXT_EDGE_RUNTIME) {
        return;
      }

      // Initialize event-driven indexing
      const { CommentJobEnqueuer } = await import('./be/CommentJobEnqueuer');
      const enqueuer = new CommentJobEnqueuer();
      enqueuer.initialize();
    },
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return CommentsFeatureModule.definition;
  }
}
